import {
  faEdit,
  faFilePdf,
  faPencilAlt,
  faPeopleCarry,
  faPlus,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import {
  getBillingShippingAddress,
  getClinicInformation,
  getCreditCards,
  getFullscriptStatus,
  getPersonalInformation,
  getPractitionerDefaultSettings,
  profilePostAction,
  uploadProfile,
} from "../../actions/profileAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import BreadCrumb from "../../components/Breadcrumb";
import ImageButton from "../../components/ImageButton";
import ImageCropper from "../../components/ImageCropper";
import InfoItem from "../../components/InfoItem";
import { BUCKET_NAME, Domain_URL } from "../../constants/states";
import {
  formatDate,
  getUserDetail,
  setFullScriptConnected,
} from "../../utils/helper";
import AddressListPopup from "./AddressListPopup";
import CardListPopup from "./CardListPopup";
import ChangeEmailPopup from "./ChangeEmailPopup";
import ClinicInformationPopup from "./ClinicInformationPopup";
import PersonalInformationPopup from "./PersonalInformationPopup";
import history from "../../utils/history";
import { getUserActiveSubscription } from "../../actions/subscriptionAction";
import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import CommissionPopup from "./CommissionPopup";
import RolePopup from "./RolePopup";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InlineIntegrationForm from "../../components/CollectJsForm/InlineIntegrationForm";
import TwoFAModal from "../../components/TwoFAModal";
const Profile = () => {
  const role = useSelector((state) => state.role.role);
  const clinicInfo = useSelector((state) => state.profile.clinicInfo);
  const cardList = useSelector((state) => state.profile.cardList);
  const addressList = useSelector((state) => state.profile.addressList);
  const userInfo = useSelector((state) => state.profile.userInfo);
  const settings = useSelector((state) => state.profile.defaultSettings);
  const subscriptionInfo = useSelector(
    (state) => state.subscription.userActiveSubscription
  );
  const dispatch = useDispatch();
  const [showPersonalModal, setShowPersonalModal] = useState(false);
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showTwoFAModal, setShowTwoFAModal] = useState(false);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [showClinicModal, setShowClinicModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showImageCropper, setShowImageCropper] = useState(false);
  const [uploadFile, getuploadFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [value, setValue] = useState(Math.random());
  const [isLoading, setIsLoading] = useState(true);
  const [isFullscriptConnected, setIsFullscriptConnected] = useState(false);

  useEffect(() => {
    dispatch(getClinicInformation());
    if (role?.val != 3) {
      dispatch(getPractitionerDefaultSettings());
    }
    dispatch(
      getFullscriptStatus((status) => {
        setIsFullscriptConnected(status);
      })
    );
    dispatch(
      getPersonalInformation(() => {
        setIsLoading(false);
      })
    );
    dispatch(getCreditCards());
    dispatch(getBillingShippingAddress());
    dispatch(
      getUserActiveSubscription(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (cardList.length > 0) {
      setSelectedCard(cardList[0]);
    } else {
      setSelectedCard(null);
    }
  }, [cardList]);

  useEffect(() => {
    if (addressList.length > 0) {
      setSelectedAddress(addressList[0]);
    } else {
      setSelectedAddress(null);
    }
  }, [addressList]);

  const disconnectFromFullscript = () => {
    var params = {
      params: {
        action: "revokeAccessToken",
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        setIsFullscriptConnected(false);
        setFullScriptConnected(false);
        dispatch(getCreatePrescriptionPatients());
      })
    );
  };

  const updatePrintHerbStatus = (status) => {
    var data = {
      printStatus: status ? 1 : 0,
    };
    var params = {
      params: {
        action: "updatePrintHerbStatus",
        data: data,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        dispatch(getPractitionerDefaultSettings());
      })
    );
  };
  const updateShowToPublic = (isPublic) => {
    var data = {
      isPublic: isPublic ? 1 : 0,
    };
    var params = {
      params: {
        action: "togglePractitionerShowToPublic",
        data: data,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        dispatch(getPractitionerDefaultSettings());
      })
    );
  };
  return (
    <div className="profile-page">
      <BreadCrumb pageName={role && role.roleName} />

      <h3 className="page-title">User Profile</h3>
      {/* <InlineIntegrationForm /> */}
      {/* <AddressPopup /> */}
      {showPersonalModal && (
        <PersonalInformationPopup
          userInfo={userInfo}
          closePopup={() => setShowPersonalModal(false)}
        />
      )}
      {showRoleModal && (
        <RolePopup
          closePopup={() => setShowRoleModal(false)}
          agency={userInfo?.license_agency}
          id={userInfo?.license_id}
        />
      )}

      {showEmailModal && (
        <ChangeEmailPopup closePopup={() => setShowEmailModal(false)} />
      )}
      {showAddressModal && (
        <AddressListPopup
          activeAddress={selectedAddress}
          setActiveAddress={setSelectedAddress}
          closePopup={() => setShowAddressModal(false)}
        />
      )}
      {showPaymentModal && (
        <CardListPopup
          setActiveCard={setSelectedCard}
          activeCard={selectedCard}
          closePopup={() => setShowPaymentModal(false)}
        />
      )}
      {showClinicModal && (
        <ClinicInformationPopup
          clinicInfo={clinicInfo}
          setShowImageCropper={setShowImageCropper}
          closePopup={() => setShowClinicModal(false)}
          setValue={setValue}
        />
      )}

      {showCommissionModal && (
        <CommissionPopup
          commission={settings.commission}
          closePopup={() => setShowCommissionModal(false)}
        />
      )}

      <p className="page-desc">Manage your profile and business information.</p>
      <div className="row">
        <div className="personal-section mt-3 col-md-6">
          <div className="d-flex align-items-center">
            <h5 className="profile-title">personal information</h5>
            <ImageButton
              text="Edit"
              icon={faEdit}
              style={{ position: "unset" }}
              onClick={() => setShowPersonalModal(true)}
            />
          </div>
          <hr className="separator" />

          <input
            accept="image/png, image/jpeg, image/jpg"
            type="file"
            id="input-file-upload"
            htmlFor="input-file-upload"
            multiple={false}
            onChange={(e) => {
              if (e.target.files[0]) {
                setProfileFile(e.currentTarget.files[0]);
                dispatch(uploadProfile(e.currentTarget.files[0]));
              }
            }}
          />
          <label type="file" id="label-file-upload" htmlFor="input-file-upload">
            <div>
              <div className="avatar">
                <img
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                  }}
                  src={
                    profileFile
                      ? URL.createObjectURL(profileFile)
                      : getUserDetail()?.hasProfilePicture
                        ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${getUserDetail()?.id
                        }.png?${Math.random()}`
                        : Avatar
                  }
                  alt="user"
                />
                <div className="pencil-icon">
                  <FontAwesomeIcon icon={faPencilAlt} size="xs" />
                </div>
              </div>
            </div>
          </label>
          {!isLoading ? (
            <>
              <InfoItem
                title="Name"
                value={`${getUserDetail()?.firstName} ${getUserDetail()?.lastName
                  }`}
              />
              <div className="d-flex align-items-center">
                <InfoItem title="Email" value={userInfo && userInfo.email} />
                {role?.val != 4 ? (
                  <>
                    <ImageButton
                      style={{ position: "unset" }}
                      text="Change Email"
                      icon={faEdit}
                      onClick={() => setShowEmailModal(true)}
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
              <InfoItem title="Phone" value={userInfo && userInfo.phone} />
              <InfoItem title="Street" value={userInfo && userInfo.address_1} />
              <InfoItem title="Apt" value={userInfo && userInfo.address_2} />
              <InfoItem title="City" value={userInfo && userInfo.city} />
              <InfoItem title="State" value={userInfo && userInfo.state} />
              <InfoItem title="Zip code" value={userInfo && userInfo.zip} />
              {(role?.val === 1 || role?.val === 6) && (
                <>
                  <div className="d-flex align-items-center mt-5">
                    <h5 className="profile-title">License information</h5>
                    {/* <ImageButton
                      text="Edit License"
                      icon={faEdit}
                      style={{ position: "unset" }}
                      onClick={() => setShowRoleModal(true)}
                    /> */}
                  </div>
                  <hr className="separator" />
                  <InfoItem
                    title="Issuing Body"
                    value={
                      userInfo && userInfo?.license_agency == "OT"
                        ? "Other"
                        : userInfo.license_agency
                    }
                  />
                  <InfoItem
                    title="License Id"
                    value={userInfo && userInfo?.license_id}
                  />

                  {userInfo && userInfo?.license_agency == "OT" && (
                    <InfoItem
                      title="License Description"
                      value={userInfo?.license_description}
                    />
                  )}
                  {userInfo && userInfo?.file && (
                    <div>
                      {(() => {
                        const fileExtension = userInfo?.file
                          .split(".")
                          .pop()
                          ?.toLowerCase();
                        if (fileExtension === "png") {
                          return (
                            <img
                              onClick={() => {
                                window.open(userInfo.file, "_blank");
                              }}
                              src={userInfo.file}
                              alt="license"
                              className="img-thumbnail"
                              style={{
                                height: "60px",
                                width: "200px",
                                objectFit: "contain",
                                cursor: "pointer",
                              }}
                            />
                          );
                        } else if (fileExtension === "pdf") {
                          return (
                            <button
                              onClick={() => {
                                window.open(userInfo.file, "_blank");
                              }}
                              className="btn btn-orange"
                            >
                              View PDF
                            </button>
                          );
                        } else {
                          return <p>Unsupported file type</p>;
                        }
                      })()}
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <ContentLoader
              speed={2}
              width={300}
              height={124}
              viewBox="0 0 300 124"
              backgroundColor="#f3f3f3"
              foregroundColor="#ffffff"
            >
              <rect x="4" y="13" rx="3" ry="3" width="410" height="6" />
              <rect x="4" y="29" rx="3" ry="3" width="380" height="6" />
              <rect x="4" y="45" rx="3" ry="3" width="178" height="6" />
              <rect x="4" y="59" rx="3" ry="3" width="410" height="6" />
              <rect x="4" y="75" rx="3" ry="3" width="380" height="6" />
              <rect x="4" y="91" rx="3" ry="3" width="178" height="6" />
            </ContentLoader>
          )}
          {role?.val == 4 ? (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Switch Role</h5>
                <ImageButton
                  icon={faUser}
                  text="Become practitioner"
                  style={{ position: "unset" }}
                  onClick={() => setShowRoleModal(true)}
                />
              </div>
              <hr className="separator" />
            </>
          ) : (
            ""
          )}
          {role?.val === 1 || role?.val === 6 ? (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Commission information</h5>
                <ImageButton
                  text={settings.commission ? "Edit" : "Add"}
                  icon={faEdit}
                  style={{ position: "unset" }}
                  onClick={() => setShowCommissionModal(true)}
                />
              </div>
              <hr className="separator" />

              <InfoItem
                title="Commission Percentage"
                value={settings.commission}
              />
            </>
          ) : (
            ""
          )}

          {role?.val === 1 || role?.val === 6 ? (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Print herbs on label</h5>
              </div>
              <hr className="separator" />

              <div className="d-flex">
                <div className="radio-item">
                  <label className="container">
                    Always
                    <input
                      radioGroup="status"
                      type="radio"
                      checked={settings.printStatus == 1}
                      name="existing"
                      onChange={() => {
                        updatePrintHerbStatus(!settings.printStatus);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="radio-item">
                  <label className="container">
                    Never
                    <input
                      radioGroup="status"
                      type="radio"
                      name="new"
                      checked={settings.printStatus == 0}
                      onChange={() => {
                        updatePrintHerbStatus(!settings.printStatus);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {role?.val === 1 || role?.val === 6 ? (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Show Your profile to patient</h5>
              </div>
              <hr className="separator" />

              <div className="d-flex">
                <div className="radio-item">
                  <label className="container">
                    Yes
                    <input
                      radioGroup="isPublic"
                      type="radio"
                      checked={settings.isPublic == 1}
                      name="isPublicTrue"
                      onChange={() => {
                        updateShowToPublic(!settings.isPublic);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="radio-item">
                  <label className="container">
                    No
                    <input
                      radioGroup="isPublic"
                      type="radio"
                      name="isPublicFalse"
                      checked={settings.isPublic == 0}
                      onChange={() => {
                        updateShowToPublic(!settings.isPublic);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {/* {isFullscriptConnected && (
            <>
              <div className="d-flex align-items-center mt-5">
                <h5 className="profile-title ">Fullscript</h5>
                <button
                  className="btn btn-orange ml-3"
                  onClick={disconnectFromFullscript}
                >
                  Disconnect From Fullscript
                </button>
              </div>
              <hr className="separator" />
            </>
          )} */}
        </div>
        <div className="personal-section mt-3 col-md-6">
          <div className="d-flex align-items-center ">
            <h5 className="profile-title ">Two Factor Authentication</h5>
            <ImageButton
              text="setup"
              icon={faMobileAlt}
              style={{ position: "unset" }}
              onClick={() => setShowTwoFAModal(true)}
            />
          </div>
          {showTwoFAModal && (
            <TwoFAModal closePopup={() => setShowTwoFAModal(false)} />
          )}
          <hr className="separator" />
          {role?.val !== 3 && (
            <div className="mb-5">
              <div className="d-flex align-items-center">
                <h5 className="profile-title">Subscription information</h5>

                {subscriptionInfo ? (
                  <ImageButton
                    text="change"
                    icon={faEdit}
                    style={{ position: "unset" }}
                    onClick={() => {
                      history.push("/app/subscription");
                    }}
                  />
                ) : (
                  <ImageButton
                    text="Subscribe"
                    icon={faPlus}
                    style={{ position: "unset" }}
                    onClick={() => {
                      history.push("/app/subscription");
                    }}
                  />
                )}
              </div>
              <hr className="separator" />
              {!isLoading ? (
                <>
                  {subscriptionInfo ? (
                    <>
                      {subscriptionInfo?.subscriptionId ? (
                        <>
                          <InfoItem
                            title="Name"
                            value={subscriptionInfo?.name}
                          />
                          <InfoItem
                            title="Duration"
                            value={`${subscriptionInfo?.duration} Month(s)`}
                          />
                          <InfoItem
                            title="Price"
                            value={`$${subscriptionInfo?.price}`}
                          />
                        </>
                      ) : (
                        ""
                      )}
                      <InfoItem
                        title="Renewal Date"
                        value={
                          subscriptionInfo?.nextChargeDate &&
                          formatDate(subscriptionInfo?.nextChargeDate)
                        }
                      />
                      <InfoItem
                        title="Status"
                        value={subscriptionInfo?.status}
                      />
                      {subscriptionInfo?.status === "Active" &&
                        subscriptionInfo?.isPaymentValid === 0 ? (
                        <>
                          <div className="invalid-payment">
                            <div className="red-line"></div>
                            <p>
                              You currently do not have a valid payment method
                              for your subscription. Please add one to avoid an
                              interruption when your subscription expires.
                            </p>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      <div className="info-item">
                        <p className="info-value">
                          You have no active subscription yet.
                        </p>
                      </div>
                    </>
                  )}{" "}
                </>
              ) : (
                <ContentLoader
                  speed={2}
                  width={300}
                  height={124}
                  viewBox="0 0 300 124"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ffffff"
                >
                  <rect x="4" y="13" rx="3" ry="3" width="410" height="6" />
                  <rect x="4" y="29" rx="3" ry="3" width="380" height="6" />
                  <rect x="4" y="45" rx="3" ry="3" width="178" height="6" />
                  <rect x="4" y="59" rx="3" ry="3" width="410" height="6" />
                  <rect x="4" y="75" rx="3" ry="3" width="380" height="6" />
                  <rect x="4" y="91" rx="3" ry="3" width="178" height="6" />
                </ContentLoader>
              )}
            </div>
          )}
          <div className="d-flex align-items-center">
            <h5 className="profile-title">Billing/Shipping information</h5>
            <ImageButton
              text="edit"
              icon={faEdit}
              style={{ position: "unset" }}
              onClick={() => setShowAddressModal(true)}
            />
          </div>
          <hr className="separator" />

          {selectedAddress && (
            <InfoItem
              title="Address"
              value={`${selectedAddress?.address_nickname
                  ? `${selectedAddress?.address_nickname} - `
                  : ""
                }
              
          ${selectedAddress?.address_1}, ${selectedAddress?.address_2 != null
                  ? `Apt ${selectedAddress?.address_2}, `
                  : ""
                } ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.zip
                }`}
            />
          )}

          <div className="d-flex align-items-center mt-5">
            <h5 className="profile-title ">Payment information</h5>
            <ImageButton
              text="edit"
              icon={faEdit}
              style={{ position: "unset" }}
              onClick={() => setShowPaymentModal(true)}
            />
          </div>
          <hr className="separator" />

          {selectedCard && (
            <InfoItem title="Credit Card" value={selectedCard.name} />
          )}
          {role?.val === 1 && (
            <>
              <div className="d-flex align-items-center  mt-5">
                <h5 className="profile-title">Clinic information</h5>
                <ImageButton
                  text={clinicInfo?.clinicId ? "Edit" : "Add"}
                  icon={faEdit}
                  style={{ position: "unset" }}
                  onClick={() => setShowClinicModal(true)}
                />
              </div>
              <hr className="separator" />
            </>
          )}
          {clinicInfo && role?.val === 1 && (
            <>
              <div className="d-flex align-items-center mt-5">
                <InfoItem title="Logo" />
                {clinicInfo?.hasLogo && (
                  <>
                    <img
                      src={`https://storage.googleapis.com/${BUCKET_NAME}/clinic/${clinicInfo?.clinicId
                        }_logo.png?+${Math.random()}`}
                      alt="logo"
                      className="img-thumbnail"
                      style={{
                        height: "60px",
                        width: "200px",
                        objectFit: "contain",
                      }}
                    />
                    <a
                      target={clinicInfo.hasLogo ? "_blank" : ""}
                      href={
                        clinicInfo.hasLogo
                          ? `${Domain_URL}api/clinicLogo?clinic_id=${clinicInfo.clinicId
                          }&token=${getUserDetail()?.token}`
                          : "javascript:void(0)"
                      }
                    >
                      <ImageButton
                        style={{ position: "unset" }}
                        disabled={clinicInfo.hasLogo}
                        text="Preview Bottle label"
                        icon={faFilePdf}
                      />
                    </a>
                  </>
                )}
              </div>

              <p
                className=" mt-5 mb-2 test-label"
                onClick={() => setShowImageCropper(true)}
              >
                Upload Clinic Logo
              </p>
              <div className="color-wrapper">
                <InfoItem title="Color Scheme" />
                <div className="color-box">
                  Headings{" "}
                  <div
                    className="color"
                    style={{ backgroundColor: clinicInfo.color_headings }}
                  />
                  Values
                  <div
                    className="color"
                    style={{ backgroundColor: clinicInfo.color_value }}
                  />
                </div>
              </div>
              <InfoItem
                title="Clinic Name"
                value={clinicInfo && clinicInfo.clinicname}
              />
              <InfoItem
                title="Website"
                value={clinicInfo && clinicInfo.website}
              />
              <InfoItem title="Email" value={clinicInfo && clinicInfo.email} />
              <InfoItem
                title="Phone"
                value={clinicInfo && clinicInfo.phone_1}
              />
              <InfoItem
                title="Secondary Phone"
                value={clinicInfo && clinicInfo.phone_2}
              />
              <InfoItem
                title="Street"
                value={clinicInfo && clinicInfo.address_1}
              />
              <InfoItem
                title="Apt"
                value={clinicInfo && clinicInfo.address_2}
              />
              <InfoItem title="City" value={clinicInfo && clinicInfo.city} />
              <InfoItem title="State" value={clinicInfo && clinicInfo.state} />

              <InfoItem title="Zip code" value={clinicInfo && clinicInfo.zip} />
              {showImageCropper && (
                <ImageCropper
                  closePopup={() => setShowImageCropper(false)}
                  clinicId={clinicInfo && clinicInfo.clinicId}
                  setValue={setValue}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default Profile;
